import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToasterService } from '../../../service/common/toaster.service';
import { CommonService, CrudComponent } from 'wire-frame';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';

import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';

import { PurchaseOrderService } from '../../../service/admin/purchaseorder.service';

// ✅ Define interface for table rows
interface OrderItem {
  itemName: string;
  manufacturingDate: string;
  expiryDate: string;
  batchNumber: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

@Component({
  selector: 'app-purchase-order',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule,
  ],
  providers: [ConfirmationService, CommonService, PurchaseOrderService],
  templateUrl: './purchaseorder.component.html',
  styleUrl: './purchaseorder.component.scss'
})
export class PurchaseOrderComponent {
  activeIndex: number = 0;
  supplierIndex: number = 0;

  public PurchaseOrderList: any[] = [];
  public editRecord: any = null;

  public PurchaseOrder = {
    id: 0,
    PurchaseOrderNumber: '',
    dateOfOrder: '',
    vendorName: '',
    status: 'Complete',
    orderItems: [] as OrderItem[], // ✅ Typed
    totalPrice: 0
  };

  // ✅ Strongly typed array
  public orderItems: OrderItem[] = [];

  public itemOptions = [
    
    { label: 'Paracetamol ( 100 ml )', value: 'Paracetamol 100' },
    { label: 'Paracetamol ( 30 ml )', value: 'Paracetamol 30' },
    { label: 'Paracetamol ( 10 ml )', value: 'Paracetamol 10' },
    { label: 'Cough Syrup ( 100 ml )', value: 'Cough Syrup 100' },
    { label: 'Cough Syrup ( 30 ml )', value: 'Cough Syrup 30' },
    { label: 'Cough Syrup ( 10 ml )', value: 'Cough Syrup 10' }
  ];

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'basic';

  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private PurchaseOrderService: PurchaseOrderService
  ) {
    this.common.breadCrum = {
      title: 'Purchase Orders',
      icon: 'shopping-cart',
      list: ['Purchase Orders'],
    };

    this.common.setCrudTableHeaders([
      { title: 'PO Number', val: 'PurchaseOrderNumber', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Date of Order', val: 'dateOfOrder', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: false, type: 'date', globalSearch: false },
      { title: 'Vendor Name', val: 'vendorName', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Total Price', val: 'totalPrice', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'number', globalSearch: false },
      { title: 'Status', val: 'status', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: false, type: 'string', globalSearch: false }
    ]);

    this.common.setCrudActions([
      { title: '', icon: 'pi-pencil', classArr: 'me-2', tooltip: 'Update Purchase Order' },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Purchase Order' }
    ]);
  }

  ngOnInit() {
    this.getPurchaseOrders();
  }

  // ===== CRUD Methods =====
  processPurchaseOrder() {
    this.PurchaseOrder.orderItems = [...this.orderItems];
    this.PurchaseOrder.totalPrice = this.calculateFinalPrice();

    if (this.PurchaseOrder?.id) {
      this.updatePurchaseOrder();
    } else {
      this.addPurchaseOrder();
    }
  }

  getPurchaseOrders() {
    this.PurchaseOrderService.getPurchaseOrder().subscribe((res: any) => {
      this.PurchaseOrderList = res.data;
    });
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() {
    this.PurchaseOrder = {
      id: 0,
      PurchaseOrderNumber: '',
      dateOfOrder: '',
      vendorName: '',
      status: 'Complete',
      orderItems: [],
      totalPrice: 0
    };
    this.orderItems = [];
  }

  addPurchaseOrder() {
    this.PurchaseOrderService.addPurchaseOrder(this.PurchaseOrder).subscribe((res: any) => {
      if (res.status) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getPurchaseOrders();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  updatePurchaseOrder() {
    this.PurchaseOrderService.updatePurchaseOrder(this.PurchaseOrder).subscribe((res: any) => {
      if (res.status) {
        this.toast.add({ severity: 'success', summary: 'Success', detail: res.message });
        this.getPurchaseOrders();
        this.closeForm();
      } else {
        this.toast.add({ severity: 'error', summary: 'Error', detail: res.message });
      }
    });
  }

  deletePurchaseOrder(item: any) {
    this.PurchaseOrderService.deletePurchaseOrder(item).subscribe((res: any) => {
      this.toast.add({ severity: 'success', summary: 'Success', detail: 'Purchase order deleted successfully' });
      this.getPurchaseOrders();
      this.closeForm();
    });
  }

  deleteRecord(event: any) {
    if (event) {
      this.deletePurchaseOrder(event);
    }
  }

  handleEvent(event: any) {
    if (event.action.tooltip == 'Update Purchase Order') {
      this.editRecord = event.data;
      this.PurchaseOrder = event.data;
      this.orderItems = event.data.orderItems || [];
      setTimeout(() => {
        this.editRecord = null;
      }, 1);
    } else if (event.action.tooltip == 'Delete Purchase Order') {
      this.editRecord = event.data;
      this.delRecPopupOpen({ title: this.editRecord?.['PurchaseOrderNumber'], obj: this.editRecord });
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  // ===== Table Row Functions =====
  addRow() {
    this.orderItems.push({
      itemName: '',
      manufacturingDate: '',
      expiryDate: '',
      batchNumber: '',
      quantity: 0,
      unitPrice: 0,
      totalPrice: 0
    });
  }

  removeRow(index: number) {
    this.orderItems.splice(index, 1);
  }

  calculateRowTotal(index: number) {
    const row = this.orderItems[index];
    const qty = Number(row.quantity) || 0;
    const price = Number(row.unitPrice) || 0;
    row.totalPrice = qty * price;
  }

  calculateFinalPrice(): number {
    return this.orderItems.reduce((sum, row) => sum + (Number(row.totalPrice) || 0), 0);
  }
}
